import { render } from "./config.html?vue&type=template&id=6d4e3da5&scoped=true&ts=true"
import script from "./config.ts?vue&type=script&lang=ts"
export * from "./config.ts?vue&type=script&lang=ts"

import "./config.scss?vue&type=style&index=0&id=6d4e3da5&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4e3da5"]])

export default __exports__